import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';

const AmenitiesCardPanel = ({amenities}) => {
    return (
        <Card className="AmenitiesCardPanel" title="Amenities">
            {amenities.map(({name}, i) => {
                return (
                    <span key={i} className="AmenitiesCardPanel-amenity">
                        {name}
                    </span>
                );
            })}
        </Card>
    );
};

AmenitiesCardPanel.propTypes = {
    amenities: PropTypes.arrayOf(PropTypes.object),
};

AmenitiesCardPanel.defaultProps = {
    amenities: [],
};

export default AmenitiesCardPanel;
